import React, { useState } from "react";
import { BsWhatsapp } from "react-icons/bs";
import { AiOutlinePlusCircle, AiOutlineShoppingCart, AiOutlineFire } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { add } from "../redux/slices/cartSlice";
import { Link } from "react-router-dom";
import { motion } from "framer-motion"; // You'll need to install framer-motion

const Product = ({ product, newProducts }) => {
  const dispatch = useDispatch();
  const isNew = newProducts?.includes(product);
  const [qty, setQty] = useState(1);
  const [isHovered, setIsHovered] = useState(false);

  const cart = useSelector((state) => state.cart.basket);
  const isCart = cart.find((item) => item?._id === product?._id);

  const addToCart = () => {
    dispatch(add({ ...product, qty }));
  };

  const handleOrderWhatsapp = () => {
    const message = `Salam, Xoş gördük!\n${product?.title} məhsulunu sifariş etmək istəyirəm.\nMəhsulun linki: https://kabelmarket.az/product/${product?.slug}`;
    const encodedMessage = encodeURIComponent(message);
    window.open(
      `https://api.whatsapp.com/send?phone=994504071417&text=${encodedMessage}`
    );
  };

  return (
    <motion.div 
      className="flex flex-col h-full rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 bg-white overflow-hidden"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      whileHover={{ y: -5 }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Product image area */}
      <Link
        to={`/product/${product?.slug}`}
        className="relative block overflow-hidden"
        aria-label={`View details for ${product?.title || 'product'}`}
      >
        {/* New product badge */}
        {isNew && (
          <div className="absolute top-4 right-4 z-10 flex items-center space-x-1.5 bg-gradient-to-r from-red-500 to-pink-500 px-4 py-2 rounded-full text-sm font-medium text-white shadow-md">
            <AiOutlineFire className="text-base animate-pulse" />
            <span>YENİ</span>
          </div>
        )}

        {/* Product image */}
        <div className="aspect-square w-full bg-gradient-to-b from-gray-50 to-white flex justify-center items-center p-6">
          <img
            src={product?.image}
            alt={product?.title || "Product image"}
            className={`max-h-[240px] w-auto max-w-full object-contain object-center transition-all duration-500 ease-out ${isHovered ? 'scale-110' : 'scale-100'}`}
            loading="lazy"
            onError={(e) => {
              e.target.src = "https://via.placeholder.com/300?text=No+Image";
            }}
          />
        </div>
      </Link>

      {/* Product info */}
      <div className="flex flex-col flex-grow p-5">
        {/* Category tag */}
        {product?.category && (
          <span className="mb-3 text-sm bg-blue-50 text-blue-600 px-3 py-1 rounded-full inline-block w-fit font-medium">
            {product?.category}
          </span>
        )}
        
        {/* Product title */}
        <Link 
          to={`/product/${product?.slug}`}
          className="group-hover:text-blue-600 transition-colors"
        >
          <h3 className="text-lg sm:text-xl font-semibold text-gray-800 line-clamp-2 mb-3 min-h-[3rem] hover:text-blue-600 transition-colors">
            {product?.title}
          </h3>
        </Link>

        {/* Price section */}
        <div className="mt-auto mb-5">
          <div className="flex items-baseline">
            <span className="font-bold text-2xl sm:text-3xl text-gray-900">
              {product?.price} ₼
            </span>
            <span className="ml-2 text-sm text-gray-500">
              / {product?.unit || "ədəd"}
            </span>
          </div>
        </div>

        {/* Action buttons */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <motion.button
            onClick={handleOrderWhatsapp}
            className="py-3.5 px-5 bg-gradient-to-r from-[#25d366] to-[#1ea952] text-white rounded-xl flex items-center justify-center text-base font-medium hover:shadow-lg transition-all"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            aria-label="Order via WhatsApp"
          >
            <BsWhatsapp className="mr-2 text-xl" />
            <span className="whitespace-nowrap">Whatsapp</span>
          </motion.button>

          {isCart ? (
            <button
              disabled
              className="py-3.5 px-5 bg-gray-100 text-gray-500 rounded-xl flex items-center justify-center text-base font-medium border border-gray-200"
              aria-label="Product already in cart"
            >
              <AiOutlineShoppingCart className="mr-2 text-xl" />
              <span className="whitespace-nowrap">Səbətdə</span>
            </button>
          ) : (
            <motion.button
              onClick={addToCart}
              className="py-3.5 px-5 bg-gradient-to-r from-amber-400 to-amber-500 text-gray-800 rounded-xl flex items-center justify-center text-base font-medium hover:shadow-lg transition-all"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              aria-label="Add to cart"
            >
              <AiOutlinePlusCircle className="mr-2 text-xl" />
              <span className="whitespace-nowrap">Səbətə at</span>
            </motion.button>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default Product;
